import React, {useEffect, useState} from 'react';
import {AtCheckbox, AtRadio} from "taro-ui";
import {LabelWidget} from "../../index";

const TCheckboxWidget = (props:any) => {
  const {label, value:wValue, currentData, updateWidgetProperty, bgColor, color, fontSize, fontStyle,inputFontSize, inputColor, inputFontStyle, onLoad, dictOnLoad, onLazyLoad, options,
    readonly,
    labelPosition,
    labelAlignment,
    isRequired,
    borderBottomColor,
    borderBottomWidth,
    labelWidth,
    placeholderAlignment,
    iconColor,
    iconAlignment
  } = props;
  const [value, setValue] = useState<any>([]);
  const onChange = (v:any)=>{
    if(!readonly){
      setValue(v);
      updateWidgetProperty&&updateWidgetProperty(v);
    }
  };
  useEffect(()=>{
    setValue(wValue??[]);
  }, [wValue])
  return (
    <LabelWidget
      label={label}
      fontSize={fontSize}
      color={color}
      fontStyle={fontStyle}
      bgColor={bgColor}
      inputFontSize={inputFontSize}
      inputColor={inputColor}
      inputFontStyle={inputFontStyle}
      labelAlignment={labelAlignment}
      labelPosition={labelPosition}
      required={isRequired}
      borderBottomColor={borderBottomColor}
      borderBottomWidth={borderBottomWidth}
      labelWidth={labelWidth}
      placeholderAlignment={placeholderAlignment}
      iconAlignment={iconAlignment}
      iconColor={iconColor}
    >
      <AtCheckbox
        options={onLoad||dictOnLoad||onLazyLoad?options:currentData}
        selectedList={value}
        onChange={onChange}
      />
    </LabelWidget>
  );
};

export default TCheckboxWidget;
